exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-loader[data-v-a8ad269c] {\n  display: inline-block;\n  background-color: #2b93ff;\n  border-radius: 50%;\n  width: 27px;\n  height: 27px;\n  margin-left: 1px;\n  margin-right: 1px;\n}\n.send-loader svg[data-v-a8ad269c] {\n    margin-top: 3px;\n    margin-left: 2px;\n}\n.send-container[data-v-a8ad269c] {\n  display: inline-block;\n  margin-left: 2px;\n}\n.bulk-send-draft-btn[data-v-a8ad269c] {\n  height: 30px !important;\n  width: 30px !important;\n  min-width: 30px !important;\n  margin: 6px 2px 5px 0px;\n}\n", ""]);

// exports
